<script>
import Cookies from "js-cookie";
import {notificationMethods, lmsUserMethods, lmsCreateUserMethods} from "@/state/helpers";
import {required, email} from "vuelidate/lib/validators";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Toast from '../../../components/widgets/toast';
import appConfig from "@/app.config";
import api from "@/helpers/axios";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Customer Users",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Toast
  },
  data() {
    return {
      visiblePassword: '',
      formError: '',
      editFormError: '',
      sites: [],
      toastAction: '',
      toastMessage: '',
      showToast: false,
      itemsLoaded: false,
      items: [],
      currentUser: JSON.parse(Cookies.get('user')),
      users: [],
      title: "Kullanıcılar Tablosu",
      headerItems: [
        {
          text: "Ana Sayfa",
          href: "/",
        },
        {
          text: "Kullanıcılar",
        },
      ],
      addSubmitted: false,
      editSubmitted: false,
      showModal: false,
      editModal: false,
      deleteModal: false,
      noDeleteModal: false,
      addForm: {
        _site: null,
        name: null,
        email: null,
        password: null,
        tcNumber: null,
        phone: null,
      },
      editForm: {
        _site: null,
        name: null,
        email: null,
        password: null,
        tcNumber: null,
        phone: null,
      },
      editId: "",
      deleteId: "",
      totalRows: 1,
      page: 1,
      perPage: 10,
      search: '',
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "name",
          label: 'Ad Soyad',
          sortable: true,
        }, {
          key: "email",
          label: 'E-Posta',
          sortable: true,
        }, {
          key: "phone",
          label: 'Telefon',
          sortable: true,
        },
        {
          key: "site",
          label: 'Site',
          sortable: true,
        },
        {
          key: "detail",
          label: "Detay",
        }, {
          key: "detail",
          label: "Detay",
        }, {

          key: "edit",
          label: "Düzenle",
        },
        {
          key: "delete",
          label: "Sil",
        },
      ],
      pageInput: 1
    };
  },

  validations: {
    addForm: {
      _site: {required},
      name: {required},
      email: {required, email},
      password: {required},
      tcNumber: {required},
      phone: {required}
    },
    editForm: {
      _site: {required},
      name: {required},
      email: {required, email},
      password: {required},
      tcNumber: {required},
      phone: {required}
    },
  },
  computed: {
    /**
     * Total no. of records
     */
    totalPages() {
      return Math.ceil(this.totalRows / this.perPage);
    },
    rows() {
      return this.items.length;
    },

  },
  watch: {
    page(newPage) {
      this.pageInput = newPage;
      this.getLmsUsers(newPage);
    },
    search(newSearch) {
      if (newSearch.length < 1) {
        if (this.page === 1) {
          this.getLmsUsers();
        } else {
          this.page = 1;
        }
      }
    },
    'addForm.email': function () {
      this.addForm.email = this.addForm.email.toLowerCase()
    },
    'editForm.email': function () {
      this.editForm.email = this.editForm.email.toLowerCase()
    }
  },
  mounted() {
    this.fetchSites();
    this.getLmsUsers();
    this.resetAddForm();
  },
  methods: {
    ...lmsUserMethods,
    ...lmsCreateUserMethods,
    ...notificationMethods,
    filterNumbers() {
      this.addForm.tcNumber = this.addForm.tcNumber.slice(0, 11);
      this.addForm.tcNumber = this.addForm.tcNumber.replace(/[^\d0-9]/g, '');
    },
    filterNumbersEdit() {
      this.editForm.tcNumber = this.editForm.tcNumber.slice(0, 11);
      this.editForm.tcNumber = this.editForm.tcNumber.replace(/[^\d0-9]/g, '');
    },
    filterNumbersPhone() {
      this.addForm.phone = this.addForm.phone.replace(/[^\d0-9]/g, '');
    },
    clearField(fieldName) {
      if (fieldName === 'email') {
        this.email = '';
      } else if (fieldName === 'password') {
        this.password = '';
      }
    },
    resetForm() {
      this.addForm = {
        _site: null,
        name: null,
        email: null,
        password: null,
        tcNumber: null,
        phone: null,
      };
      this.addSubmitted = false;
    },
    validateNameEdit() {
      if (this.editForm.name) {
        const isValidName = /^[A-Za-zÇçĞğİıÖöŞşÜü\s]+$/.test(this.editForm.name);
        if (!isValidName) {
          this.editForm.name = this.editForm.name.replace(/[^A-Za-z\s]+/g, '');
        }
      }
    }, validateNameAdd() {
      if (this.addForm.name) {
        const isValidName = /^[A-Za-zÇçĞğİıÖöŞşÜü\s]+$/.test(this.addForm.name);
        if (!isValidName) {
          this.addForm.name = this.addForm.name.replace(/[^A-Za-z\s]+/g, '');
        }
      }
    },
    formatPhoneNumber() {
      if (this.addForm.phone) {
        let formattedNumber = this.addForm.phone.replace(/\D/g, '');
        if (formattedNumber.charAt(0) === '0') {
          formattedNumber = formattedNumber.slice(1);
        }
        if (formattedNumber.length === 10) {
          const areaCode = formattedNumber.slice(0, 3);
          const firstPart = formattedNumber.slice(3, 6);
          const secondPart = formattedNumber.slice(6, 8);
          const lastPart = formattedNumber.slice(8, 10);
          formattedNumber = `0 (${areaCode}) ${firstPart} ${secondPart} ${lastPart}`;
          this.addForm.phone = formattedNumber;
        } else {
          this.addForm.phone = '';
        }
      }
    },
    isValidPhoneNumber(phoneNumber) {
      const phoneNumberRegex = /^(05\d{9}|05\d{8}|[1-9]\d{9})$/;
      return phoneNumberRegex.test(phoneNumber);
    },
    isValidTCKN(tcNumber) {
      if (tcNumber && tcNumber.length === 11) {
        const firstDigit = parseInt(tcNumber.charAt(0), 10);
        if (
            firstDigit !== 0 &&
            tcNumber.split('').every(char => !isNaN(char)) &&
            parseInt(tcNumber.charAt(10), 10) % 2 === 0
        ) {
          return true;
        }
      }
      return false;
    },
    doSearch() {
      if (this.page === 1) {
        this.getLmsUsers();
      } else {
        this.page = 1;
      }
    },
    async fetchSites() {
      try {
        const response = await api.get("/sites");
        this.sites = response.data.data.docs;
      } catch (error) {
        return;
      }
    },
    formatSite(site) {
      return site
    },
    getLmsUsers(page = this.page) {
      this.itemsLoaded = false;
      this.fetchLmsUsers({page, limit: this.perPage, search: this.search}).then(res => {
        this.totalRows = res.total;
        this.items = res.docs.map(elem => {
          return elem;
        })
        this.itemsLoaded = true;
      })
    },
    handleSubmit() {
      this.addSubmitted = true;
      this.formError = "";


      this.$v.addForm.$touch();
      if (
          this.$v.addForm.$invalid
      ) {
        return;
      }
      else if (!this.isValidTCKN(this.addForm.tcNumber)) {
        this.formError = "";
        return;
      }else {
        this.createLmsUser({
          ...this.addForm,
        }).then(() => {
          this.toastMessage = "Kullanıcı başarıyla eklendi!";
          this.toastAction = "success";
          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
          }, 3000)
          this.showModal = false;
          this.getLmsUsers();
          this.addForm.name = "";
          this.addForm.phone = "";
          this.addForm.email = "";
          this.addForm.password = "";
          this.addForm.tcNumber = "";
        }).catch((err) => {

          if (err == 'IDENTITY_ALREADY_USE') {
            this.formError = "Girilen TC Kimlik numarasına sahip bir kullanıcı bulunmaktadır."
          } else if (err == 'EMAIL_ALREADY_USE') {
            this.formError = "Girilen E-Posta adresine sahip bir kullanıcı bulunmaktadır."
          }  else {
            this.toastMessage = "Sistemde bir hata oluştu!";
            this.toastAction = "error";
            this.showToast = true;
            setTimeout(() => {
              this.showToast = false;
            }, 3000)
          }
        })
      }
    },
    handleEditSubmit() {
      this.editSubmitted = true;
      this.editFormError = "";
      this.$v.editForm.$touch();
      if (this.$v.editForm.$invalid) {
        return;
      } else if (!this.isValidTCKN(this.editForm.tcNumber)) {
        this.formError = "";
        return;
      }else {
        this.editForm._site = String(this.editForm._site);
        let data = JSON.parse(JSON.stringify(this.editForm))
        this.updateLmsUser({id: this.editId, data}).then(() => {
          this.toastMessage = "Kullanıcı başarıyla düzenlendi!";
          this.toastAction = "success";
          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
          }, 3000);
          this.editModal = false;
          this.getLmsUsers();
          this.addForm.name = "";
          this.addForm.phone = "";
          this.addForm.email = "";
          this.addForm.password = "";
          this.addForm.tcNumber = "";
        })
            .catch((err) => {
              if (err === 'IDENTITY_ALREADY_USE') {
                this.formError = "Girilen TC Kimlik numarasına sahip bir kullanıcı bulunmaktadır.";
              } else {
                this.toastMessage = "Sistemde bir hata oluştu!";
                this.toastAction = "error";
                this.showToast = true;
                setTimeout(() => {
                  this.showToast = false;
                }, 3000);
              }
            });
      }
    },
    handleDeleteSubmit() {
      this.deleteLmsUser(this.deleteId).then(() => {
        this.deleteModal = false;
        this.toastMessage = "Kullanıcı başarıyla silindi!";
        this.toastAction = "success";
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
        }, 3000)
        this.getLmsUsers();
      })
    },
    openEdit(user) {
      this.editForm.name = user.name;
      this.editForm.email = user.email;
      this.editForm.tcNumber = user.tcNumber;
      this.editForm.phone = user.phone;
      this.editForm.password = user.password;
      this.editForm.email = user.email;
      this.editId = user.id;
      this.editForm._site = user._site.id;
      this.editModal = true;
    }
    ,
    openDelete(user) {
      if (user.email === this.currentUser.email) {
        this.noDeleteModal = true;
      } else {
        this.deleteId = user.id;
        this.deleteModal = true;
      }
    },
    resetAddForm() {
      this.addForm = {
        _site: null,
        name: null,
        email: null,
        password: null,
        tcNumber: null,
        phone: null,
      };
      this.addSubmitted = false;
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems"/>
    <Toast :action="this.toastAction" :message="this.toastMessage" v-if="showToast"></Toast>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Ara:
                    <b-form-input
                        v-model="search"
                        @keyup.enter="doSearch"
                        type="search"
                        placeholder="ara..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
                <button
                    class="btn btn-success ms-auto mb-2"
                    @click="showModal = true; resetForm();"
                >
                  Kullanıcı Ekle
                </button>
              </div>
            </div>
            <div v-if="itemsLoaded">
              <div class="table-responsive mb-0">
                <b-table
                    class="datatables"
                    :items="items"
                    :fields="fields"
                    :sort-by="sortBy" :sort-desc="sortDesc"
                    responsive="sm"
                >
                  <template v-slot:cell(site)="data">
                    {{ formatSite(data?.item?._site?.name) }}
                  </template>


                  <template v-slot:cell(detail)="data">
                    <button
                        class="btn btn-info d-flex py-2"
                        @click="$router.push({name:'customerUserDetail',params:{customerUserId: data.item.id}})"
                    >
                      <i :class="`bx bxs-detail bx-xs `"></i>
                    </button>
                  </template>
                  <template v-slot:cell(phone)="data">

                    {{  data.item?.phone?.replace(/\D/g, '' ) }}

                  </template>
                  <template v-slot:cell(edit)="data">
                    <button
                        class="btn btn-warning d-flex py-2"
                        @click="openEdit(data.item)"
                    >
                      <i :class="`bx bxs-edit bx-xs`"></i>
                    </button>
                  </template>
                  <template v-slot:cell(delete)="data">
                    <button
                        :disabled="currentUser.role.includes('user')"
                        class="btn btn-danger d-flex py-2"
                        @click="openDelete(data.item)"
                    >
                      <i :class="`bx bx-trash bx-xs`"></i>
                    </button>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                      class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <input
                          :style="{width:'50px', maxWidth:'100%', display:'flex',justifyContent:'center', marginTop:'-3px'}"
                          @keyup.enter="page=pageInput" v-model="pageInput" type="text" class="form-control">
                      <b-pagination
                          v-model="page"
                          :total-rows="totalRows"
                          :per-page="perPage"
                          :sort-by="sortBy" :sort-desc="sortDesc"
                      ></b-pagination>
                    </ul>
                  </div>
                  <div class="page-info mt-2"> Toplam sayfa sayısı {{ totalPages }}</div>
                </div>
              </div>
            </div>
            <div class="spinner-wrapper" v-else>
              <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
            </div>
          </div>
        </div>
      </div>
      <b-modal v-model="showModal" title="Kullanıcı Ekle" hide-footer>
        <form @submit.prevent="handleSubmit">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <div class="form-group">
                  <label for="site">Site Seçiniz</label>
                  <select id="site" v-model="addForm._site" class="form-control" :class="{
    'is-invalid': addSubmitted && $v.addForm._site.$error,
  }">
                    <option value="">Site Seçiniz</option>
                    <option v-for="site in sites" :key="site.id" :value="site.id">{{ site.name }}</option>
                  </select>
                  <div
                      v-if="addSubmitted && !$v.addForm._site.required"
                      class="invalid-feedback"
                  >
                    Site seçilmesi gerekli bir alandır.
                  </div>
                </div>

              </div>
            </div>

            <div class="col-12">
              <div class="mb-3">
                <label for="name">Ad Soyad</label>
                <input
                    id="name"
                    type="text"
                    v-model="addForm.name"
                    class="form-control"
                    placeholder="Ad giriniz"
                    :class="{
        'is-invalid': addSubmitted && $v.addForm.name.$error,
      }"
                    @input="validateNameAdd"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.name.required"
                    class="invalid-feedback"
                >
                  Ad girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="email">Email</label>
                <input
                    name="email"
                    id="email"
                    type="email"
                    v-model="addForm.email"
                    @focus="clearField('email')"
                    class="form-control"
                    placeholder="Email giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.email.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && $v.addForm.email.$error"
                    class="invalid-feedback"
                >
                  <span v-if="!$v.addForm.email.required">Email girilmesi gerekli bir alandır.</span>
                  <span v-if="!$v.addForm.email.email">Lütfen geçerli bir email giriniz.</span>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="phone">Telefon Numarası</label>
                <input
                    :class="{ 'is-invalid': addSubmitted && $v.addForm.phone.$error }"
                    name="phone"
                    id="phone"
                    type="text"
                    autocomplete="off"
                    v-model="addForm.phone"
                    class="form-control"
                    placeholder="Telefon Numarası giriniz"
                    @blur="formatPhoneNumber"
                    @input="filterNumbersPhone"
                />
                <div v-if="addSubmitted && $v.addForm.phone.$error" class="invalid-feedback">
                  <span v-if="!$v.addForm.phone.required">Telefon numarası girilmesi gerekli bir alandır.</span>
                </div>
              </div>
            </div>




            <div class="col-12">
              <div class="mb-3">
                <label for="tcNumber">TC Kimlik Numarası</label>
                <input
                    name="tcNumber"
                    id="tcNumber"
                    type="number"
                    autocomplete="off"
                    :class="{
                    'is-invalid': addSubmitted && !isValidTCKN(addForm.tcNumber)
                     }"
                    v-model="addForm.tcNumber"
                    class="form-control"
                    placeholder="TC Kimlik Numarası giriniz"
                    @input="filterNumbers"
                    maxlength="11"
                />

                <span v-if="addSubmitted && !isValidTCKN(addForm.tcNumber)" class="invalid-feedback">
      Geçerli bir TC Kimlik Numarası giriniz.
    </span>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="password">Şifre</label>
                <input
                    name="password"
                    id="password"
                    type="password"
                    v-model="addForm.password"
                    class="form-control"
                    placeholder="Şifre giriniz"
                    @focus="clearField('password')"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.password.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && $v.addForm.password.$error"
                    class="invalid-feedback"
                >
                  <span v-if="!$v.addForm.password.required">Şifre girilmesi gerekli bir alandır.</span>
                </div>
              </div>
            </div>
          </div>
          <div
              v-if="formError.length>0"
              class="text-danger d-flex justify-content-end"
          >
            <p>{{ formError }}</p>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="showModal = false; resetForm();">Vazgeç</b-button>
            <b-button type="submit" variant="success" class="ms-1">Kullanıcı Ekle</b-button>

          </div>

        </form>
      </b-modal>
      <b-modal v-model="editModal" title="Kullanıcı Düzenle" hide-footer>
        <form @submit.prevent="handleEditSubmit" autocomplete="off">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <div class="form-group">
                  <label for="site">Site Seçiniz</label>
                  <select id="site" v-model="editForm._site" class="form-control" :class="{
                    'is-invalid': editSubmitted && $v.editForm._site.$error,
                  }">
                    <option v-for="site in sites" :key="site.id" :value="site.id">{{ site.name }}</option>
                  </select>
                  <div
                      v-if="editSubmitted && !$v.editForm._site.required"
                      class="invalid-feedback"
                  >
                    Site seçilmesi gerekli bir alandır.
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="name">Ad Soyad</label>
                <input
                    id="name"
                    type="text"
                    v-model="editForm.name"
                    class="form-control"
                    placeholder="Ad giriniz"
                    :class="{
        'is-invalid': editSubmitted && $v.editForm.name.$error,
      }"
                    @input="validateNameEdit"
                />
                <div
                    v-if="editSubmitted && !$v.editForm.name.required"
                    class="invalid-feedback"
                >
                  Ad girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="email">Email</label>
                <input
                    name="email"
                    id="email"
                    type="email"
                    v-model="editForm.email"
                    class="form-control"
                    placeholder="Email giriniz"
                    :class="{
                    'is-invalid': editSubmitted && $v.editForm.email.$error,
                  }"
                />
                <div
                    v-if="editSubmitted && $v.editForm.email.$error"
                    class="invalid-feedback"
                >
                  <span v-if="!$v.editForm.email.required">Email girilmesi gerekli bir alandır.</span>
                  <span v-if="!$v.editForm.email.email">Lütfen geçerli bir email giriniz.</span>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="phone">Telefon Numarası</label>
                <input
                    :class="{
        'is-invalid': (editSubmitted && $v.editForm.phone.$error) && !isValidPhoneNumber(editForm.phone),
      }"
                    name="phone"
                    id="phone"
                    type="text"
                    autocomplete="off"
                    v-model="editForm.phone"
                    class="form-control"
                    placeholder="Telefon Numarası giriniz"
                />
                <div

                    v-if="(editSubmitted && $v.editForm.phone.$error) && !isValidPhoneNumber(editForm.phone)"
                    class="invalid-feedback"
                >

                  <span v-if="editSubmitted && !isValidPhoneNumber(editForm.phone)">Lütfen geçerli bir telefon numarası giriniz.</span>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="tcNumber">TC Kimlik Numarası</label>
                <input
                    name="tcNumber"
                    id="tcNumber"
                    type="number"
                    autocomplete="off"
                    :class="{
                    'is-invalid': editForm && !isValidTCKN(editForm.tcNumber)
                     }"
                    v-model="editForm.tcNumber"
                    class="form-control"
                    placeholder="TC Kimlik Numarası giriniz"
                    @input="filterNumbersEdit"
                    maxlength="11"
                />
                <span v-if="editSubmitted && !isValidTCKN(editForm.tcNumber)" class="invalid-feedback">
      Geçerli bir TC Kimlik Numarası giriniz.
    </span>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="password">Şifre</label>
                <!-- Hidden input for the password with a default value -->
                <input type="hidden" v-model="editForm.password" value="YourDefaultValue" />

                <!-- Visible input (type="password") with an empty value -->
                <!--                <input
                                    name="password"
                                    id="password"
                                    type="password"
                                    v-model="visiblePassword"
                                    class="form-control"
                                    placeholder="Şifre giriniz"
                                />-->
                <input
                    name="password"
                    id="password"
                    type="password"
                    v-model="editForm.password"
                    class="form-control"
                    placeholder="Şifre giriniz"
                />

              </div>
            </div>

          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="editModal = false"
            >Vazgeç
            </b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Kullanıcı Düzenle
            </b-button
            >
          </div>
        </form>
      </b-modal>
      <b-modal
          v-model="deleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Sil !</h4>
              <p class="text-muted font-size-14 mb-4">
                Bu kullanıcıyı silmek istediğinize emin misiniz? Silinmiş kullanıcıları geri alamazsınız.
              </p>

              <form @submit.prevent="handleDeleteSubmit">
                <button class="btn btn-danger" type="submit" id="button-addon2">
                  Evet, eminim
                </button>
              </form>
            </div>
          </div>
        </div>
      </b-modal>
      <b-modal
          v-model="noDeleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Silinemez !</h4>
              <p class="text-muted font-size-14 mb-4">
                Oturumunu açtığınız kullanıcıyı silemezsiniz.
              </p>
            </div>
          </div>
        </div>
      </b-modal>
    </div>

  </Layout>
</template>
<style scoped>
.pill {
  display: inline-block;
  margin: 10px 10px 0 0;
  padding: 6px 0px 4px 0px;
  background: #2a3042;
  border-radius: 10px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}

.form-control:-webkit-autofill,
.form-control:-webkit-autofill:focus {
  transition: background-color 5000s ease-in-out 0s !important;
  background-color: #fff !important; /* Özel bir renk veya saydam bir renk ayarlayabilirsiniz */
}

.pill span {
  padding: 6px 12px 4px 12px !important;
}
</style>
